import { makeAutoObservable } from 'mobx';

import { serverBaseWebSocketUrl } from '../general-utilities/urlUtils';

class LiveUsersStore {
  liveUsers: { name: string; initials: string }[] = [];

  socket: WebSocket | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setLiveUsers(users: { name: string; initials: string }[]) {
    this.liveUsers = users;
  }

  clearLiveUsers(){
    this.liveUsers = [];
  }

  connectWebSocket(campaignId: string, orgId: number) {
    if (this.socket) return;
    const wsConnectionStr = `${serverBaseWebSocketUrl}/ws/org/${orgId}/campaign/${campaignId}/users/`;
    this.socket = new WebSocket(wsConnectionStr);

    this.socket.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        if (data.type === 'users' && Array.isArray(data.users)) {
          const formattedUsers = data.users.map((usr: 
            {
              id: string; 
              username: string; 
              email: string; 
              first_name: string; 
              last_name: string; 
              initials: string;
            }) => ({
            name: `${usr.first_name} ${usr.last_name}` || usr.username,
            initials: usr.initials
          }));
          this.setLiveUsers(formattedUsers);
        }
      } catch (error) {
        console.error('Error parsing WebSocket message:', error);
      }
    };

    this.socket.onclose = () => {
      this.socket = null;
    };
  }

  closeWebSocket() {
    if (this.socket) {
      this.socket.close();
      this.socket = null;
    }
  }
}

const liveUsersStore = new LiveUsersStore();
export default liveUsersStore;
